import React, { useEffect, useState, Fragment } from 'react'
import { Menu, MenuItem } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { sortMenuStyles } from '../../styles/classes/FieldFormClasses'
import { faBarsSort } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const sortStyle = {
  width: '15px',
  height: '15px',
  marginLeft: '6px',
  cursor: 'pointer'
}

export const SortMenu = props => {
  const [iconFlipper, setIconFlipper] = useState(false)
  const { t } = useTranslation()
  const { classes } = sortMenuStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  useEffect(() => {
    if (props.order === 'desc') {
      if (props.id === 'last_edit_date') {
        setIconFlipper('vertical')
      } else {
        setIconFlipper(false)
      }
    } else {
      if (props.id === 'last_edit_date') {
        setIconFlipper(false)
      } else {
        setIconFlipper('vertical')
      }
    }
  }, [props.orderBy, props.order])

  const handleSelect = order => {
    props.onSelectSort(order, props.id)
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <FontAwesomeIcon
        icon={faBarsSort}
        flip={props.id === props.orderBy ? iconFlipper : false}
        onClick={handleClick}
        style={sortStyle}
      />
      <Menu
        id={props.id}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
      >
        <MenuItem
          onClick={() => handleSelect('asc')}
          className={classes.menuItem}
        >
          {t('field_forms.sort_menu.sort')}{' '}
          {props.id !== 'last_edit_date' && 'A'}
          {props.id === 'last_edit_date' &&
            t('field_forms.sort_menu.newest')} -{' '}
          {props.id !== 'last_edit_date' && 'Z'}
          {props.id === 'last_edit_date' && t('field_forms.sort_menu.oldest')}
        </MenuItem>
        <MenuItem
          onClick={() => handleSelect('desc')}
          className={classes.menuItem}
        >
          {t('field_forms.sort_menu.sort')}{' '}
          {props.id !== 'last_edit_date' && 'Z'}
          {props.id === 'last_edit_date' &&
            t('field_forms.sort_menu.oldest')} -{' '}
          {props.id !== 'last_edit_date' && 'A'}
          {props.id === 'last_edit_date' && t('field_forms.sort_menu.newest')}
        </MenuItem>
      </Menu>
    </Fragment>
  )
}
